import { Stack, styled, Typography } from "@mui/material";
import PrimaryButton from "components/button/PrimaryButton";
import FlexBetween from "components/flexbox/FlexBetween";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const Section = styled("section")(({ theme }) => ({}));

export const Section7 = () => {
  const innerHeight = window.innerHeight;
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: false,
    margin: `${-innerHeight / 4}px`,
  });

  return (
    <Section
      ref={ref}
      sx={{
        position: "relative",
        scrollSnapAlign: "center",
      }}
    >
      <Stack
        spacing={5}
        sx={{ height: "100%", width: "100%", px: { xs: 0, md: 20 } }}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <FlexBetween gap={{ xs: 5, md: 20 }} justifyContent={'center'} sx={{ flexWrap: { xs: 'wrap', md: 'nowrap' } }}>
          <Stack minWidth={300} alignItems={'center'}>
            <motion.img
              src="static/svg/firework.svg"
              style={{ height: "45vh", maxWidth: '300px' }}
              initial={{
                transform: "scale(0) translateY(-50px)",
                opacity: 0,
              }}
              animate={{
                transform: `scale(${isInView ? 1 : 0}) translateY(-${isInView ? 0 : 50
                  }px)`,
                opacity: isInView ? 1 : 0,
              }}
              transition={{
                delay: 0.2,
              }}
            />
          </Stack>
          <Stack spacing={3}>
            <motion.div
              initial={{
                transform: `translateX(50vw) scaleY(0)`,
                opacity: 0,
              }}
              animate={{
                transform: `translateX(${isInView ? 0 : 50}vw) scaleY(${isInView ? 1 : 0
                  })`,
                opacity: isInView ? 1 : 0,
              }}
              transition={{
                type: "spring",
                stiffness: 700,
                damping: 30,
                delay: 0.6,
              }}
            >
              <Typography
                sx={{
                  textTransform: "uppercase",
                  fontWeight: 700,
                  fontSize: { xs: 24, md: 32 },
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                JOIN THE COMMUNITY
              </Typography>
            </motion.div>
            <motion.div
              style={{ width: "100%" }}
              initial={{
                transform: `translateX(50vw) scaleY(0)`,
                opacity: 0,
              }}
              animate={{
                transform: `translateX(${isInView ? 0 : 50}vw) scaleY(${isInView ? 1 : 0
                  })`,
                opacity: isInView ? 1 : 0,
              }}
              transition={{
                type: "spring",
                stiffness: 700,
                damping: 40,
                delay: 0.7,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: { xs: 16, md: 24 },
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Become an early and active trader in the Flaex community to have
                the opportunity to earn additional airdrops from the Flaex
                Foundation.
              </Typography>
            </motion.div>
            <motion.div
              initial={{
                y: 20,
                opacity: 0,
              }}
              animate={{ y: isInView ? 0 : 20, opacity: isInView ? 1 : 0 }}
              transition={{ duration: 0.2, delay: 0.9 }}
            >
              <PrimaryButton
                sx={{
                  background: "linear-gradient(90deg,#AA3AF6,#FDA9E5)",
                  color: "#000",
                  fontWeight: 700,
                  fontSize: { xs: 18, md: 20 },
                  margin: { xs: "auto", md: "unset" },
                }}
              >
                JOIN FLAEX DISCORD
              </PrimaryButton>
            </motion.div>
          </Stack>
        </FlexBetween>
      </Stack>
    </Section>
  );
};
